/* eslint-disable @typescript-eslint/no-explicit-any */
import Loader from '@mercadoni/sinister/dist/cjs/mystiqueLoader'
import Modal from '@mercadoni/sinister/dist/cjs/mystiqueModal'
import ReplacementsComponent from '@mercadoni/sinister/dist/cjs/replacements'
import { Suspense } from 'react'
import styled from 'styled-components'
import { CopyLocale, ProductCatalog } from '~types/index'

const ReplacementsModal = styled(Modal)`
  &.ant-modal {
    max-width: 760px;
    .ant-modal-content {
      padding: 0;
      max-width: 100vw;
      .ant-modal-body {
        padding: 0;
      }
    }
  }
`
interface ReplacementsProps {
  onCancel: () => void
  product: ProductCatalog
  copies: CopyLocale
  isMobile: boolean
  theme?: any
}

const Replacements = ({
  onCancel,
  product,
  copies,
  isMobile,
}: ReplacementsProps) => {
  const handleCancel = () => {
    onCancel()
  }

  return (
    <ReplacementsModal
      open
      fullscreen={isMobile}
      onCancel={handleCancel}
      width="90%"
      withBodyStyles={false}
      closeIcon={null}
    >
      <Suspense fallback={<Loader />}>
        <ReplacementsComponent
          product={product}
          onCancel={onCancel}
          copies={copies}
        />
      </Suspense>
    </ReplacementsModal>
  )
}

export default Replacements
